import "./ReportSixthSection.css";

const DEFAULT_ROADMAP = {
  phase30: {
    theme: "Discovery & Validation",
    actions: [
      "Conduct 30+ structured customer interviews to confirm pain intensity and willingness to pay.",
      "Map 5–8 direct and indirect competitors; document your differentiation gaps.",
      "Define your North Star Metric and set a Week-4 baseline measurement.",
      "File provisional IP protection or trademark registration if applicable to your sector.",
    ],
  },
  phase60: {
    theme: "Build & Pilot",
    actions: [
      "Launch a Minimum Viable Product (MVP) targeting your most pain-aware customer segment.",
      "Onboard 10–20 paid or committed pilot users and collect structured qualitative feedback.",
      "Validate core unit economics: CAC, LTV, and gross margin estimates against your model.",
      "Refine pricing strategy based on real willingness-to-pay signals observed during pilot.",
    ],
  },
  phase90: {
    theme: "Launch & Measure",
    actions: [
      "Execute first commercial launch through your primary acquisition channel.",
      "Track North Star Metric weekly; set a target of 15–20% month-on-month growth.",
      "Prepare a 10-slide pitch deck for incubation programs or seed-round fundraising.",
      "Apply to at least two Startup India-recognized incubators or government grant programs.",
    ],
  },
};

const PHASE_CONFIG = [
  { key: "phase30", label: "DAY 1 – 30", accent: "#0077d6" },
  { key: "phase60", label: "DAY 31 – 60", accent: "#7c3aed" },
  { key: "phase90", label: "DAY 61 – 90", accent: "#059669" },
];

export default function ReportSixthSection({ res }) {
  const aiReport =
    res?.sectionScores?.aiReport ??
    res?.sectionScores?.ai_report ??
    res?.aiReport ??
    {};

  const roadmap = aiReport.milestoneRoadmap ?? DEFAULT_ROADMAP;

  return (
    <div className="r6-section">
      <div className="r6-header">
        <span className="r6-header-title">90-DAY MILESTONE ROADMAP</span>
        <span className="r6-header-brand">MarsMate AI</span>
      </div>

      <div className="r6-body">
        <div className="r6-phases-grid">
          {PHASE_CONFIG.map(({ key, label, accent }) => {
            const phase = roadmap[key] ?? DEFAULT_ROADMAP[key];
            const actions = Array.isArray(phase?.actions) ? phase.actions : [];

            return (
              <div
                className="r6-phase-card"
                key={key}
                style={{ borderTopColor: accent }}
              >
                <div className="r6-phase-label" style={{ color: accent }}>
                  {label}
                </div>
                <div className="r6-phase-theme">{phase?.theme ?? "—"}</div>
                <div className="r6-phase-divider" style={{ backgroundColor: accent }} />
                <ul className="r6-phase-actions">
                  {actions.map((action, i) => (
                    <li key={i} className="r6-phase-action-item">
                      <span
                        className="r6-action-dot"
                        style={{ backgroundColor: accent }}
                      />
                      <span>{action}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>

      <div className="r6-footer">
        <span>© MarsMate AI &nbsp;·&nbsp; info@marsmateai.com &nbsp;·&nbsp; www.marsmateai.com</span>
      </div>
    </div>
  );
}
